import { render, staticRenderFns } from "./SwapProviderMentions.vue?vue&type=template&id=f1ebad04&scoped=true&"
import script from "./SwapProviderMentions.vue?vue&type=script&lang=js&"
export * from "./SwapProviderMentions.vue?vue&type=script&lang=js&"
import style0 from "./SwapProviderMentions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SwapProviderMentions.vue?vue&type=style&index=1&id=f1ebad04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ebad04",
  null
  
)

export default component.exports